import { api, setConfig, UPDATE_GAME_CATEGORY_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const editGameCategory = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/categories/update', mapEntityToApi(data), setConfig(data)).then((res) => {
		return { message: UPDATE_GAME_CATEGORY_MESSAGE, gameCategory: res.data.data };
	});
